import { Collapse as AntCollapse } from 'antd';
import { styled } from 'styled-components';

export const StyledAccordion = styled(AntCollapse)`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  .ant-collapse-item {
    border-color: ${props => props.theme.colors.secondary.light.divider};

    .ant-collapse-header {
      background-color: ${props => props.theme.colors.secondary.light.surfaceBg};
      color: ${props => props.theme.colors.secondary.main.text};

      &:hover {
        background-color: ${props => props.theme.colors.secondary.light.surfaceHover};
      }

      .ant-collapse-expand-icon {
        color: ${props => props.theme.colors.secondary.main.icon};
      }
    }

    .ant-collapse-content {
      background-color: ${props => props.theme.colors.secondary.light.contentBg};
      color: ${props => props.theme.colors.secondary.main.text};
      border-color: ${props => props.theme.colors.secondary.light.divider};
    }
  }
`;

export const StyledPanel = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid ${props => props.theme.colors.secondary.light.divider};
  border-radius: 4px;
  margin-bottom: 8px;

  &.active {
    border-color: ${props => props.theme.colors.primary.main.border};
  }
`;

export const StyledPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  width: 100%;
  max-width: 100%;
  background-color: ${props => props.theme.colors.secondary.light.surfaceBg};
  color: ${props => props.theme.colors.secondary.main.text};
  cursor: pointer;

  &.active {
    border-bottom: 1px solid ${props => props.theme.colors.secondary.light.divider};
  }

  &:hover {
    background-color: ${props => props.theme.colors.secondary.light.surfaceHover};
  }

  .icon {
    color: ${props => props.theme.colors.secondary.main.icon};
  }
`;

export const StyledPanelContent = styled.div`
  padding: 16px;
  width: 100%;
  max-width: 100%;
  background-color: ${props => props.theme.colors.secondary.light.contentBg};
  color: ${props => props.theme.colors.secondary.main.text};
`;
